import React, { useEffect } from 'react';
import { AppShell } from '@mantine/core';
import AppSidebar from './components/structure/AppSidebar';
import {
	BrowserRouter,
	Route,
	Routes,
} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// Routes
import Home from './components/sections/Home';
import Login from './components/sections/Login';
import NotFound from './components/sections/NotFound';
import Levels from './components/sections/Levels';
import Partners from './components/sections/Partners';
import Categories from './components/sections/Categories';
import Branches from './components/sections/Branches';
import Benefits from './components/sections/Benefits';
import Posts from './components/sections/Posts';
import BetaUsers from './components/sections/BetaUsers';
import PartnerUsers from './components/sections/PartnerUsers';
import Users from './components/sections/Users';
import Notifications from './components/sections/Notifications';
import Challenges from './components/sections/Challenges';
import CorporatePartners from './components/sections/CorporatePartners';
import Locations from './components/sections/Locations';
import Settings from './components/sections/Settings';
import TenantUsers from './components/sections/TenantUsers';
import CorporateAdmins from './components/sections/CorporateAdmins';
import Cities from './components/sections/Cities';
import Supports from './components/sections/Supports';
import BannerInApp from './components/sections/BannerInApp';

function App() {

	// State and hooks
	const isLoggedIn = useSelector(state => state.authData.isLoggedIn);
	const dispatch = useDispatch();

	// Routes
	const openRoutes = [
		{
			path: '*',
			component: NotFound
		}
	];

	// Check if logged in and set
	useEffect(() => {
		if (localStorage.getItem('webikecc_jwt')) {
			dispatch.authData.toggleLoggedIn(true);
			dispatch.authData.setToken(localStorage.getItem('webikecc_jwt'));
		}
	}, [dispatch]);

	return (
		<BrowserRouter>
			<AppShell
				padding={0}
				navbar={isLoggedIn ? <AppSidebar /> : null}
				header={null}
				styles={(theme) => ({
					main: {
						backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
						color: theme.colorScheme === 'dark' ? '#FFFFFF' : '#000000'
					},
				})}
			>
				{isLoggedIn ?
					// Protected routes
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/levels" element={<Levels />} />
						<Route path="/partners" element={<Partners />} />
						<Route path="/categories" element={<Categories />} />
						<Route path="/branches" element={<Branches />} />
						<Route path="/benefits" element={<Benefits />} />
						<Route path="/posts" element={<Posts />} />
						<Route path="/beta_users" element={<BetaUsers />} />
						<Route path="/partner_users" element={<PartnerUsers />} />
						<Route path="/users" element={<Users />} />
						<Route path="/notifications" element={<Notifications />} />
						<Route path="/challenges" element={<Challenges />} />
						<Route path="/corporate_partners" element={<CorporatePartners />} />
						<Route path="/corporate_admins" element={<CorporateAdmins />} />
						<Route path="/locations" element={<Locations />} />
						<Route path="/cities" element={<Cities />} />
						<Route path="/settings" element={<Settings />} />
						<Route path="/tenant_users" element={<TenantUsers />} />
						<Route path="/supports" element={<Supports />} />
						<Route path="/banner_in_app" element={<BannerInApp />} />
						{openRoutes.map((item, i) => <Route key={i} exact path={item.path} element={<item.component />} />)}
					</Routes>
					:
					// Public
					<Routes>
						<Route exact path="/" element={<Login />} />
						{openRoutes.map((item, i) => <Route key={i} exact path={item.path} element={<item.component />} />)}
					</Routes>
				}
			</AppShell>
		</BrowserRouter>
	);

}

export default App;
